import { useI18n } from '@change-corgi/core/react/i18n';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';

import { SUGGESTED_TEMPLATE_NOTICE } from '../../../../constants';
import { useCreatePetitionUpdateContext } from '../../context';
import type { UseCreatePetitionUpdateFormResult } from '../../types';
import { useLocalStoragePetitionUpdateForm } from '../useLocalStorage';

export function useGetInitialValues(): UseCreatePetitionUpdateFormResult['data']['initialValues'] {
	const isTemplateFilled = useCreatePetitionUpdateContext();
	const { translate, translatePlural } = useI18n();
	const {
		data: {
			petition: {
				id,
				signatureState: {
					signatureCount: { displayed },
				},
			},
		},
	} = useStarterDashboardV2PageData();
	const { petitionUpdateFormValues } = useLocalStoragePetitionUpdateForm(id, isTemplateFilled);

	return {
		title:
			isTemplateFilled && !petitionUpdateFormValues.title
				? translate(`corgi.petition_update.prefill_templates.${SUGGESTED_TEMPLATE_NOTICE}.title`)
				: petitionUpdateFormValues.title,
		description:
			isTemplateFilled && !petitionUpdateFormValues.description
				? translatePlural(
						`corgi.petition_update.prefill_templates.${SUGGESTED_TEMPLATE_NOTICE}.description`,
						displayed,
						{ signatureCount: displayed },
					)
				: petitionUpdateFormValues.description,
	};
}
